package game.scenes;

import cerastes.SoundManager;
import cerastes.LocalizationManager;
import cerastes.ui.UIEntity;
import h2d.ScaleGrid;
import cerastes.SaveLoad.GameSaveType;
import cerastes.Timer;
import game.shader.TVFuzzFilter;
import h2d.col.Bounds;
import cerastes.c2d.Vec2;
import game.ui.UIPartSocket;
import cerastes.misc.Random;
import cerastes.fmt.CUIResource;
import h2d.Flow;
import game.ui.UIPart;
import cerastes.ui.Reference;
import game.ui.UIBBS;
import data.Parts;
import cerastes.Utils;
import hxd.Key;
import cerastes.c2d.DebugDraw;

enum abstract RepairTool(Int) from Int to Int
{
	var None;
	var Tweezers;
	var Probe;
}

@:keep
class RepairScene extends LDScene
{

	@:obj public var refBbs: Reference;
	@:obj public var btnBbs: cerastes.ui.Button;
	@:obj public var ctnScreenSignal: h2d.Object;
	@:obj public var bgScreen: h2d.Bitmap;

	@:obj public var btnProbe: cerastes.ui.Button;
	@:obj public var btnTweezers: cerastes.ui.Button;
	@:obj public var btnPower: cerastes.ui.Button;

	@:obj public var ledRed: h2d.Bitmap;
	@:obj public var ledGreen: h2d.Bitmap;

	@:obj public var ctnPcb: h2d.Object;
	@:obj public var flowParts: Flow;
	@:obj public var bmpPcb: ScaleGrid;
	@:obj public var bmpFuzz: h2d.Bitmap;

	@:obj public var bmpConsole: h2d.Bitmap;
	@:obj public var txtConsole: h2d.Text;

	@:obj public var btnNext: cerastes.ui.Button;
	@:obj public var btnPrev: cerastes.ui.Button;
	@:obj public var btnSkip: cerastes.ui.Button;
/*
	@:obj public var refPart1: Reference;
	@:obj public var refPart2: Reference;
	@:obj public var refPart3: Reference;
	@:obj public var refPart4: Reference;
*/

	@:obj public var ctnPart1: h2d.Object;
	@:obj public var ctnPart2: h2d.Object;
	@:obj public var ctnPart3: h2d.Object;
	@:obj public var ctnPart4: h2d.Object;
	
	
	var parts: Array<UIPart> = [];


	var bbs: UIBBS;

	var consoleDef: ConsolePCBDef;

	public static var tool: RepairTool = Tweezers;

	var sockets: Array<UIPartSocket> = [];
	var tvFilter: TVFuzzFilter;
	public static var isOn = false;

	var fixed = false;

	var canTweezer = true;
	var canProbe = true;
	var canPower = true;
	var canBBS = true;

	var partPage = 0;


	override function enter()
	{
		super.enter();

		initUI( "ui/repair_scene.ui" );

		SoundManager.playMusicFile("music/song_c.ogg");

		var root = s2d;
		cerastes.macros.UIPopulator.populateObjects();


		createComponents();
		bbs = cast refBbs.get();


		btnBbs.onActivate = (e) -> {
			if( !canBBS ) return;
			resetButtons();
			bbs.show();
			btnBbs.enabled = false;
			SoundManager.play("button");
		}

		
		trackCallback(
			UIBBS.registerOnClosed(this, (e) -> { resetButtons(); return e; } ),
			UIBBS.unregisterOnClosed
		);


		var repairs = data.Repairs.getRepairs(GameState.data.day);
		var repair = repairs[GameState.data.repair];

		trace('day=${GameState.data.day}');

		trace(repair);

		createRepair(repair.seed, repair.difficulty, repair.console );

		btnProbe.onActivate = (e) -> {
			if( fixed || !canProbe ) return; 
			resetButtons();
			powerOff(); 
			tool = Probe;
			btnProbe.enabled = false;
			SoundManager.play("button");
		}
		btnTweezers.onActivate = (e) -> { 
			if( fixed || !canTweezer ) return; powerOff(); 
						resetButtons();
			tool = Tweezers;
			btnTweezers.enabled = false;
			SoundManager.play("button");
		  }

		btnPower.onActivate = (e) -> { 

			btnPower.toggled = isOn;
			if( fixed || !canPower ) return;

			resetButtons();

			powerOn(); 
			btnPower.toggled = isOn;
			SoundManager.play("button");
		}

		tvFilter = new game.shader.TVFuzzFilter(152,139,1);
		bmpFuzz.filter = tvFilter;
		tool = Tweezers;
		bmpFuzz.visible =false;

		btnNext.onActivate = (e) -> {
			partPage++;
			updatePartsPage();
		};
		btnPrev.onActivate = (e) -> {
			partPage--;
			updatePartsPage();
		}

		btnSkip.onActivate = (e) -> {
			finishRepair();
		}

		ensureParts();
		

		GameState.flow.jumpFile('data/day${GameState.data.day}.flow', 'repair_start_${GameState.data.repair}');
        s2d.addChild( cerastes.c2d.DebugDraw.g );
	}

	function updatePartsPage()
	{

		if( partPage >= 3 )
			partPage = 0;
		if( partPage < 0 )
			partPage = 2;

		var idx = 1;
		for( p in Parts.parts )
		{
			if( p.type == partPage )
			{
				var ctn: h2d.Object = cast ui.getObjectByName('ctn_part${idx}');
				var part: UIPart = cast ctn.getChildAt(0);
				if( part == null )
					continue;
				part.setPart( p );
				part.visible = true;
				idx++;
			}
		}
		for( i in idx ... 5 )
		{
			var ctn: h2d.Object = cast ui.getObjectByName('ctn_part${i}');
			var part: UIPart = cast ctn.getChildAt(0);
			if( part != null )
				part.visible = false;
		}
	}

	function resetButtons()
	{
		btnBbs.enabled =true;
		btnTweezers.enabled = true;
		btnProbe.enabled =true;
		btnPower.toggled =false;
	}

	function checkTutorial()
	{
		
		switch( GameState.data.day )
		{
			case 1: 
				var phase = GameState.get("tutorial_phase");
				switch(phase)
				{
					case 0:
						//GameState.set("tutorial_phase",1);
						//GameState.flow.jumpFile( "data/day1.flow", "repair_day1_0");
						canTweezer = false;
						canProbe = false;
						canPower = false;
						canBBS = false;
						tool = None;
					case 2: 
						GameState.set("tutorial_phase",3);
						canProbe = true;

					case 4: 
						ledRed.alpha= 1; 
					case 5:
						GameState.set("tutorial_phase",6);
						canProbe = false;
						canTweezer = true;
						tool = None;

					case 7: 
						GameState.set("tutorial_phase",8);
						canProbe = false;
						canTweezer = false;
						canBBS = true;
						tool = None;
					case 9: 
						GameState.set("tutorial_phase",10);
						canProbe = false;
						canTweezer = true;
						canBBS = false;
						tool = None;
					case 10: 
						if( checkFixed() )
						{
							GameState.set("tutorial_phase",11);
							GameState.flow.jumpFile( "data/day1.flow", "repair_day1_4");

						}

					case 12: 
						GameState.set("tutorial_phase",13);
						canProbe = false;
						canTweezer = false;
						canBBS = false;
						canPower = true;
						tool = None;

					default: 
				}
			default:
		}
	}

	function powerOn()
	{
		bmpFuzz.visible =false;

		if( isOn )
		{
			powerOff();
			
			return;
		}
		isOn = true;

		ctnScreenSignal.visible = true;
		ctnScreenSignal.removeChildren();

		if( checkFixed() )
		{
			var ui = hxd.Res.loader.load(consoleDef.bootSequence).to(CUIResource).toObject();
			ctnScreenSignal.addChild( ui );
			ui.runTimeline("boot");	

			fixed = true; 

			new Timer(5,finishRepair);
		}
		else 
		{
			ctnScreenSignal.addChild( bmpFuzz );
			bmpFuzz.visible = true;
			bmpFuzz.filter = tvFilter;
		}
		
	}

	function finishRepair()
	{
		
		GameState.flow.jumpFile('data/day${GameState.data.day}.flow', 'repair_${GameState.data.repair}');
		GameState.data.repair++;
		/*
		var repairs = data.Repairs.getRepairs(GameState.data.day);
		if( GameState.data.repair >= repairs.length )
		{
			GameState.data.day++;
			GameState.data.repair = 0;
			GameState.flow.jumpFile('data/day${GameState.data.day}.flow');
		}
		else 
			switchToNewScene("game.scenes.RepairScene");
		*/
	}

	function powerOff()
	{
		bgScreen.filter = null;
		ctnScreenSignal.visible = false;
		tool = Tweezers;
		isOn = false;
	}

	function checkFixed()
	{
		for(s in sockets )
		{
			var p: UIPart = s.uipart;
			if( p == null )
				return false; 

			if( p.defective )
				return false; 

			var d = p.part;

			if( d.type != s.desiredPart.type  )
				return false;

			if( d.value != s.desiredPart.value  )
				return false;
		}

		return true;
	}

	override function tick( delta:Float )
	{
		super.tick(delta);

		handleProbe();

		checkTutorial();

		if( tvFilter != null )
			tvFilter.update(delta);


		ensureParts();

	}

	function ensureParts()
	{
		if( UIEntity.draggingEntity == null )
		{
			ensurePart( ctnPart1, 0 );
			ensurePart( ctnPart2, 1 );
			ensurePart( ctnPart3, 2 );
			ensurePart( ctnPart4, 3 );
		}
	}

	function ensurePart( ctn: h2d.Object, id: Int )
	{
		if( ctn.numChildren == 0 )
		{
			var ui = hxd.Res.loader.load("ui/part.ui").to(CUIResource).toObject(ctn);
			updatePartsPage();
		}
		while( ctn.numChildren > 1 )
		{
			ctn.removeChild( ctn.getChildAt(0) );
		}
	}

	override function exit()
	{
		super.exit();
	}


	override function preload()
	{
		super.preload();
	}

	function handleProbe()
	{
		ledRed.alpha = 0.1;
		ledGreen.alpha = 0.1;

		if( tool != Probe )
			return;

		if( !hxd.Key.isDown( hxd.Key.MOUSE_LEFT ) )
			return;

		var point = new Vec2( s2d.mouseX, s2d.mouseY );
		var b = new Bounds();
		b.addPoint( point );
		point.x++;
		point.y++;
		b.addPoint( point );

		for( so in sockets )
		{
			var bounds = so.getDragBounds();
			if( !bounds.intersects( b ) )
				continue;

			var p = so.uipart;
			if( p == null )
				continue;

			if( p.defective )
			{
				ledRed.alpha = 1;
				if( GameState.data.day == 1 && GameState.get("tutorial_phase") == 3 )
				{
					GameState.set("tutorial_phase", 4 );
					GameState.flow.jump("repair_day1_1");
				}
			}
			else 
				ledGreen.alpha = 1;
		}
	}

	function buildPCB( console: ConsoleType )
	{
		var cp = Parts.getConsole( console );
		sockets = [];

		// @todo pcb
		//ctnPcb.removeChildren();		

		bmpPcb.width = cp.pcbWidth;
		bmpPcb.height = cp.pcbHeight;

		for( p in cp.parts )
		{
			var part = Parts.lookupPart(  p.type, p.value );
			if( part == null )
				continue;
			// Make a socket for each part
			var uisocket: UIPartSocket = cast hxd.Res.loader.load( "ui/part_socket.ui" ).to(CUIResource).toObject( ctnPcb );
			var uipart: UIPart = cast hxd.Res.loader.load( "ui/part.ui" ).to(CUIResource).toObject( );

			uisocket.setPart(uipart);
			uisocket.setPartAccepted( part );

			uisocket.x = p.x;
			uisocket.y = p.y;

			uipart.setPart(part);
			uipart.setGeneric();

			sockets.push(uisocket);
		}
	}

	function createRepair( seed: Int, difficulty: Int, console: ConsoleType )
	{
		var r = new Random( seed );

		var brokenParts = difficulty;

		buildPCB(console);


		consoleDef = Parts.getConsole( console );

		if( consoleDef.sprite != null )
			bmpConsole.tile = Utils.getTile(consoleDef.sprite);

		txtConsole.text = LocalizationManager.localize('console_type_${console}').toLowerCase();


		var cp = consoleDef;
		for( i in 0 ... brokenParts )
		{
			var idx = r.getUpTo( cp.parts.length-1 );
			var uisocket: UIPartSocket  = cast ctnPcb.getChildAt( idx );
			var part = uisocket.uipart;
			part.setDefective( );
			
		}
		
	}
}
